"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This is a i18next backend to chain multiple other backends and caches.
 * So you can define an additional caching backend or fallback backends.
 *
 * Greatly inspired by https://github.com/i18next/i18next-chained-backend,
 * minus the old bugs, and added brand new ones.
 */
var ChainedBackend = /** @class */ (function () {
    /**
     * @param backends List of backends in the chain. Those need to be already instanciated
     */
    function ChainedBackend(backends) {
        this.type = "backend";
        backends.forEach(function (backend) {
            if (typeof backend !== "object" || backend.type !== "backend") {
                throw "Provided backend is not an instance or a backend instance";
            }
        });
        this.backends = backends;
    }
    ChainedBackend.prototype.init = function (services, backendOption, globalOptions) {
        // Initialize all the backend in the chain.
        this.backends.forEach(function (backend) { return backend.init(services, backendOption, globalOptions); });
    };
    ChainedBackend.prototype.read = function (language, namespace, callback) {
        var _this = this;
        var backendsLength = this.backends.length;
        var errorStack = [];
        // Recursive function to load the language from the a backend
        var loadFromBackendAtIndex = function (index, canRetry) {
            if (canRetry === void 0) { canRetry = false; }
            if (index >= backendsLength) {
                return callback("All backend failed to load data: " + errorStack.join(", "), canRetry);
            }
            var backend = _this.backends[index];
            if (backend.read) {
                try {
                    backend.read(language, namespace, function (err, data) {
                        if (data && typeof data === "object" && Object.keys(data).length > -1) {
                            // Data was found. Callback into i18next to use the data
                            callback(undefined, data);
                            // Save the data on all backends precededding this one.
                            // This enable caching backend to work in the chain.
                            saveToBackendAtIndex(index - 1, data);
                        }
                        else {
                            errorStack.push(err);
                            // Load from next, propagating the canRetry flag if true, or pass the current retry flag (data) otherwise
                            loadFromBackendAtIndex(index + 1, canRetry || !!data);
                        }
                    });
                }
                catch (e) {
                    errorStack.push(e);
                    // Try next backend
                    loadFromBackendAtIndex(index + 1, canRetry);
                }
            }
            else {
                // Backend does not have a read method, trying next one
                loadFromBackendAtIndex(index + 1, canRetry);
            }
        };
        // Recursive function to save the language data to a backend
        var saveToBackendAtIndex = function (index, data) {
            if (index < 0)
                return;
            var backend = _this.backends[index];
            if (backend.save) {
                backend.save(language, namespace, data);
                saveToBackendAtIndex(index - 1, data);
            }
            else {
                saveToBackendAtIndex(index - 1, data);
            }
        };
        // Start the loading process with the first backend
        loadFromBackendAtIndex(0);
    };
    ChainedBackend.prototype.create = function (languages, namespace, key, fallbackValue) {
        this.backends.forEach(function (b) {
            if (b.create)
                b.create(languages, namespace, key, fallbackValue);
        });
    };
    return ChainedBackend;
}());
// Need to set the type on the constructor function too to allow using un-initialized module to be passed to
// i18next.use()
ChainedBackend.type = "backend";
exports.default = ChainedBackend;
//# sourceMappingURL=ChainedBackend.js.map